var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useRef } from 'react';
import { ActionsTooltipMessage } from '../Actions/ActionsTooltipMessage';
import PublicRoomContext from '../../../../application/Context/PublicRoomContext';
import ReactTimeAgo from 'react-time-ago';
import useOutsideClick from "../../shared-components/useOutsideClick";
export var MessageHeader = function (_a) {
    var id = _a.id, author = _a.author, date = _a.date, likes = _a.likes, likeCount = _a.likeCount, isAuthor = _a.isAuthor, threadId = _a.threadId, lastName = _a.lastName;
    var _b = useContext(PublicRoomContext), currentUserId = _b.currentUserId, selectedChannel = _b.selectedChannel, likeMessage = _b.likeMessage, unlikeMessage = _b.unlikeMessage;
    var initials = author.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    var userLikedMessage = likes.some(function (like) { return like.user.id == currentUserId; });
    // Close tooltip when user click anywhere 
    var tooltipRef = useRef(null);
    useOutsideClick(tooltipRef, function () {
        setControllersTooltip("");
    });
    var _c = __read(React.useState(''), 2), controllersTooltip = _c[0], setControllersTooltip = _c[1];
    var handleControllersTooltip = function (e) {
        var eleId = e.target.getAttribute('data-id');
        if (controllersTooltip === eleId) {
            setControllersTooltip('');
        }
        else {
            setControllersTooltip(eleId);
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: "post-comment-unit-header" }, { children: [_jsxs("div", __assign({ className: 'post-header-unit-top' }, { children: [_jsx("div", __assign({ className: 'post-avatar-col' }, { children: _jsx("div", __assign({ className: 'post-avatar' }, { children: initials })) })), _jsx("div", { children: _jsx("p", __assign({ className: 'comment-auth-name' }, { children: author })) })] })), _jsx("div", __assign({ className: 'post-comment-controllers', ref: tooltipRef }, { children: _jsxs("div", __assign({ className: 'post-controllers' }, { children: [controllersTooltip === "tooltip-".concat(id) && isAuthor && (_jsx(ActionsTooltipMessage, { threadId: threadId, messageId: id, type: "message" })), _jsxs("div", __assign({ className: 'post-controllers-container' }, { children: [_jsxs("div", __assign({ className: 'show-likes-section', "data-tooltip-id": "msg" + id }, { children: [userLikedMessage ?
                                                    _jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/like-filled.svg"), alt: "like", className: "icon-heart", onClick: function (e) { return unlikeMessage(e, selectedChannel, threadId, id); } }) :
                                                    _jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/heart-b.svg"), alt: "like", className: "icon-heart", onClick: function (e) { return likeMessage(e, selectedChannel, threadId, id); } }), likeCount] })), isAuthor && _jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/vertical-dots.svg"), alt: "dots", "data-id": "tooltip-".concat(id), onClick: function (e) { return handleControllersTooltip(e); } })] }))] })) }))] })), _jsx("p", __assign({ className: 'time-ago' }, { children: _jsx(ReactTimeAgo, { date: new Date(date), locale: "en-us", timeStyle: "twitter" }) }))] }));
};
